var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeiboMobileComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.493 0A2.5 2.5 0 0 1 13 2.496v6.008A2.494 2.494 0 0 1 10.5 11h-2L7 13H6l-1.447-2h-2.05A2.5 2.5 0 0 1 0 8.504V2.496A2.5 2.5 0 0 1 2.507 0zM12 1H1v9h4l1 1.5h1.001L8 10h4zM4.5 5v1h-2V5zm3 0v1h-2V5zm3 0v1h-2V5z"
})));
export default SvgWeiboMobileComment;